import { IDepartmentData } from '@/models';
import { IDepartmentService } from './department.types';
import { AxiosInstance } from 'axios';

export class DepartmentService implements IDepartmentService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/departments/';
  }

  fetchDepartments(production?: boolean): Promise<IDepartmentData[]> {
    return this.axios
      .get<IDepartmentData[]>(`${this.endpoint}`, {
        params: { production: production }
      })
      .then(({ data }) => data);
  }

  fetchDepartment(id: number): Promise<IDepartmentData> {
    return this.axios
      .get<IDepartmentData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createDepartment(data: IDepartmentData): Promise<IDepartmentData> {
    return this.axios
      .post<IDepartmentData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateDepartment(data: IDepartmentData): Promise<IDepartmentData> {
    return this.axios
      .patch<IDepartmentData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteDepartment(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
